export enum AnalyticsEvents {
  VendorSelected = 'Selected Vendor',
  QuoteStatusPage = 'Quote Status Page',
  QuoteStatusPageViewed = 'Quote Status Page Viewed',
  QuoteStatusPageRedirected = 'Quote Status Page Redirected',
  ExploreVendorsClicked = 'Explore Vendors With Promotions Clicked',
  LandingGetStartedClicked = 'Landing Modal Get Started Clicked',
  SelectedAddAnotherClicked = 'Selected Modal Add Another Clicked',
  SelectedRequestQuotesClicked = 'Selected Modal Request Quotes Clicked',
}
